<div class="bg-image"></div>
<div align="center" >
        <div class="content">
            <div class="row">
                <div class="col-12">
                    <span>
                        <img src="assets/img/pUnityC_RGB_app_72pipp_72ppi.png" class="img-fluid" alt="UnityC Logo">
                    </span>

                </div>
                <div  *ngIf="!isUserAvailable" class="text-center col-md-12 padding-bottom-20 padding-top-20 divider">
                    <mat-icon>arrow_back</mat-icon><a [routerLink]="['/login']">Back to login page</a>
                </div>
                <div class="col-12">
                    <div class="padding-left-30 padding-right-30">
                        <div class="display-block text-center semi-bold-font padding-top-10 padding-bottom-10" *ngIf="isUserAvailable">
                            <h2 class="font-20">Terms & Conditions have changed and must be accepted in order to utilize Unity</h2>
                        </div>

                        <div class="row col-10 padding-top-20 bg-white">
                            <div innerHtml="{{termsAndConditions}}"></div>
                            <div class="padding-top-20 padding-bottom-35">
                                <span class="padding-left-30" *ngIf="isUserAvailable">
                                    <label>
                                        <input type="checkbox"
                                               [checked]="accepted"
                                               (change)="accepted = !accepted">
                                        I Accept
                                    </label>
                                </span>
                                <span class="padding-left-30"  *ngIf="isUserAvailable">
                                    <button mat-button class="unity-btn-bg regular-font"
                                            [disabled]="!accepted"
                                            (click)="submit()" >
                                        Next
                                    </button>
                                </span>
                                <div *ngIf="!isUserAvailable" class="text-center col-md-12 padding-bottom-20 padding-top-20" style="font-size: 1.6rem">
                                    <mat-icon>arrow_back</mat-icon><a [routerLink]="['/login']">Back to login page</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


<div *ngIf="lockScreenService && lockScreenService.lockScreen" class="lock-screen">
    <div id="spinner">
        <span>Loading...</span>
    </div>
</div>
